<template>
    <div class="uploadFileWrap">
        <!-- 上传弹窗 -->
        <el-dialog
                class="uploadFileDialog"
                :title="$t('message.Iupload1')"
                :visible.sync="uploadFileDialogVisible"
                width="400px"
                :close-on-click-modal="false"
                :close-on-press-escape="!saveLoading"
                :show-close="!saveLoading"
                :before-close="beforeClose"
                @close="initUpload">
            <div class="uploadFileDialogWrap">
                <el-upload
                        ref="upload"
                        class="upload"
                        drag
                        multiple
                        :data="{act: uploadAct,type: uploadType}"
                        :before-upload="uploadBefore"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :on-remove="uploadRemove"
                        action="/CommonHandler/CommonHandler.ashx">
                    <i class="el-icon-upload"></i>
                    <div v-if="$getCookie('i18n') === 'zhCHS'" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div v-else class="el-upload__text">Drag the file here, <em>or click upload</em></div>
                </el-upload>
                <div v-if="isShowUploadSuccessAnimation" class="uploadSuccessAnimation">
                    <UploadFileSuccessAnimation></UploadFileSuccessAnimation>
                </div>
                <div class="btnBox">
                    <el-button v-if="saveLoading"
                               type="primary"
                               disabled>{{$t('message.Iuploading')}}</el-button>
                    <el-button v-else
                               type="primary"
                               :disabled="uploadFileList.length === 0"
                               @click="saveFiles">{{$t('message.save')}}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    // 上传文件成功的动画组件
    import UploadFileSuccessAnimation from '@/components/plugin/UploadFileSuccessAnimation';

    export default {
        name: 'UploadFile',// 上传文件组件
        components: {
            UploadFileSuccessAnimation,
        },
        props: {
            // 显示组件
            show: {
                type: Number,
                default: -1
            },
            // 文件位置 0-传往商城、1-传往内控
            type: {
                type: String,
                default: ''
            },
            // 上传的文件类型（内控专用）
            uploadType: {
                type: String,
                default: ''
            },
            // 托单号
            orderBillCode: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                uploadFileDialogVisible: false,// 附件上传弹窗-显示
                uploadFileList: [],// 已上传的文件列表
                isShowUploadSuccessAnimation: false,// 显示上传成功动画
            };
        },
        computed: {
            // 获取act
            uploadAct() {
                return this.type === '0' ? 'postFileStreamData' : 'fileUpLoad';
            },
            // 附件保存加载中
            saveLoading() {
                return !!this.uploadFileList.filter(item => !item.success).length;
            }
        },
        watch: {
            // 显示组件
            show() {
                // 显示上传弹窗
                this.uploadFileDialogVisible = true;
            },
        },
        methods: {
            // 初始化上传附件
            initUpload() {
                this.$refs.upload.abort();// 取消所有上传请求
                this.$refs.upload.clearFiles();// 清空文件列表
                this.uploadFileList = [];// 清空已上传的文件列表
            },
            // 上传-上传前回调
            uploadBefore(file) {
                if (file.name.length > 100) {
                    this.$Alert({
                        msg: '文件名不能超过100位!'
                    });
                    return false;
                }
                this.$bigData('上传文件选择', '上传文件选择', `${this.orderBillCode}+${file.name}`);
                // 添加到文件列表
                this.uploadFileList.push({
                    uid: file.uid,
                    id: '',
                    name: '',
                    url: '',
                    success: false,
                });
            },
            // 上传-成功回调
            uploadSuccess(res, file) {
                if (res.generalErrMsg) {// 通用错误
                    this.errUploadFiles(file);// 上传文件服务器错误回调
                    this.$generalErrFn(res.data.generalErrMsg);
                    return;
                } else if (res.errMsg) {// 普通错误
                    this.errUploadFiles(file);// 上传文件服务器错误回调
                    this.$Alert({
                        msg: res.errMsg
                    });
                    return;
                }
                this.$bigData('上传文件成功', '上传文件成功', `${this.orderBillCode}+${file.name}`);
                // 显示上传成功动画
                this.isShowUploadSuccessAnimation = true;
                // 动画维持 2500ms
                this.$setTimeout(() => {
                    this.isShowUploadSuccessAnimation = false;
                }, 2500);
                // 修改文件信息及成功状态
                for (let i = 0; i < this.uploadFileList.length; i++) {
                    if (this.uploadFileList[i].uid === file.uid) {
                        this.uploadFileList[i].id = this.type === '0' ? res.success.id : res.success.orderPicID;
                        this.uploadFileList[i].name = res.success.name;
                        this.uploadFileList[i].url = res.success.url;
                        this.uploadFileList[i].success = true;
                        break;
                    }
                }
            },
            // 上传-网络错误的回调
            uploadError(err, file) {
                this.$Message({
                    msg: `"${file.name}"${file.c2wdqd}`
                });
                // 上传-移除附件回调
                this.uploadRemove(file);
            },
            // 上传文件服务器错误回调
            errUploadFiles(file) {
                this.$bigData('上传文件服务器错误', '上传文件服务器错误', `${this.orderBillCode}+${file.name}`);
                this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(item => item.uid !== file.uid);
                // 上传-移除附件回调
                this.uploadRemove(file);
            },
            // 上传-移除附件回调
            uploadRemove(file) {
                this.uploadFileList = this.uploadFileList.filter(item => file.uid !== item.uid);
            },
            // 保存文件
            saveFiles() {
                // 发送给父组件
                let saveList = [];// 发送给父组件的数据
                this.uploadFileList.forEach(item => {
                    item.success && saveList.push({
                        id: item.id,
                        name: item.name,
                        url: item.url,
                    });
                });
                this.$emit('save', saveList);
                // 关闭文件上传
                this.uploadFileDialogVisible = false;
            },
            beforeClose(done) {
                if (this.uploadFileList.length > 0) {
                    this.$Alert({
                        type: 'warning',
                        msg: '请点击保存按钮'
                    });
                } else {
                    done();
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .uploadFileWrap {
        .uploadFileDialog {
            /deep/ .el-dialog__body {
                padding: 0 20px 30px 20px;

                .uploadFileDialogWrap {
                    position: relative;

                    .uploadSuccessAnimation {
                        position: absolute;
                        top: 0;
                        box-sizing: border-box;
                        width: 360px;
                        height: 180px;
                        background-color: white;
                        border: 1px dashed #d9d9d9;
                        border-radius: 6px;
                    }

                    .upload {
                        margin-top: 7px;
                    }

                    .btnBox {
                        margin-top: 10px;
                        text-align: right;
                    }
                }
            }
        }
    }
</style>
